import { AuthenticatedRepository } from "..";
import { FileHeader, IFileRepository } from "../../domain/file";
import { IFileHeaderBean } from "./beans";
import { FileTranslators } from "./translators";

export class FileRepository extends AuthenticatedRepository implements IFileRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getFileHeaders(folderGuid: string): Promise<FileHeader[]> {
    const url = "/api/folder/" + folderGuid + "/files";
    const result = await this.get(url);
    return this.toFileHeaders(folderGuid, result.data);
  }

  private toFileHeaders(folderGuid: string, beans: IFileHeaderBean[]): FileHeader[] {
    if (!beans) { return []; }
    return beans.map(b => FileTranslators.toFileHeader(() => this.token, folderGuid, b));
  }

  async deleteFile(folderGuid: string, fileId: string): Promise<void> {
    const url = "/api/folder/" + folderGuid + "/file/" + fileId + "/delete";
    await this.post(url);
  }

  async uploadFile(folderGuid: string, fileName: string, file: File): Promise<void> {
    const url = "/api/folder/" + folderGuid + "/upload";
    const formData = new FormData();
    formData.append("fileName", fileName);
    formData.append("data", file);
    const headers = { "content-type": "multipart/form-data" };
    await this.post(url, formData, { headers });
  }

  downloadBatchFiles(folderGuid: string): string {
    return "/api/folder/" + folderGuid + "/files/download?token=" + this.token;
  }
}
